import { useTranslation } from 'react-i18next';
import { ReactComponent as IconStakeholders } from 'assets/icons/IconStakeholders.svg';
import clsx from 'clsx';
import Button from 'components/Button/Button';
import Checkbox from 'components/Checkbox/Checkbox';
import { BUTTON_VARIANT } from 'constants/interfaces';
import { CONST_DISABLED_STAKEHOLDERS } from 'constants/materialAssessment';

import type IStakeholderCard from './interfaces/IStakeholderCard';

import styles from './scss/StakeholderCard.module.scss';

function StakeholderCard({
  id,
  title,
  checked,
  onCheck,
  onClickTitle,
  clickBtn,
  status,
  hasRefusalDetails = false,
  isViewOnly = false,
}: IStakeholderCard) {
  const { t } = useTranslation();
  const canViewRefusalDetails = !checked && hasRefusalDetails && Boolean(onClickTitle);

  const handleClickTitle = () => {
    if (!canViewRefusalDetails) {
      return;
    }

    onClickTitle?.(id);
  };

  return (
    <div className={clsx(styles.root, {
      [styles.checked]: checked,
    })}
    >
      <div className={styles.titleWrapper}>
        <IconStakeholders />
        <Checkbox
          name={id}
          value={id}
          checked={checked || false}
          onChange={() => onCheck?.(id)}
          className={styles.checkbox}
          disabled={CONST_DISABLED_STAKEHOLDERS.includes(id) || isViewOnly}
        />
      </div>
      <div className={styles.contentWrapper}>
        {canViewRefusalDetails ? (
          <button
            type="button"
            className={styles.titleButton}
            onClick={handleClickTitle}
            aria-label={`${t(`materialityAssessment.${title}`)} ${t('materialityAssessment.detailsRefusal')}`}
          >
            <span className={styles.title}>{t(`materialityAssessment.${title}`)}</span>
          </button>
        ) : (
          <span className={styles.title}>{t(`materialityAssessment.${title}`)}</span>
        )}
        <span className={styles.status}>
          {t('materialityAssessment.status')}
          {': '}
          {t(`materialityAssessment.${status}`)}
        </span>
        <Button
          title={t('materialityAssessment.configure')}
          variant={BUTTON_VARIANT.cancel}
          className={styles.button}
          onClick={() => clickBtn?.(title)}
          disabled={!checked || CONST_DISABLED_STAKEHOLDERS.includes(id)}
        />
      </div>
    </div>
  );
}

export default StakeholderCard;
